/* eslint-disable */
import { post, get, getJSON } from "../../../http";
import { BehaviorSubject } from "rxjs";

export interface IHistoryReportsConfig {
  baseUrl: string;
}

export interface HistoryReportDTO {
  reportId: string;
  name: string;
  date?: string;
}

export class HistoryReportsService {
  public historyReports$ = new BehaviorSubject<HistoryReportDTO[]>([]);
  protected _baseUrl: string;

  constructor(config: IHistoryReportsConfig) {
    this._baseUrl = `${config.baseUrl}/historyreports`;
  }

  public async openReport(reportId: string, reportName: string) {
    const dto: HistoryReportDTO = {
      reportId,
      name: reportName,
    };
    try {
      const response = await post(`${this._baseUrl}`, dto);
      const result = await response.json();
      const currentHistory = this.historyReports$.value;
      this.historyReports$.next(currentHistory.concat([result]));
    } catch (err) {
      console.error("Error Open report");
    }
  }

  public async fetchHistoryReports() {
    try {
      const result = await getJSON<HistoryReportDTO[]>(`${this._baseUrl}`);
      this.historyReports$.next(result);
    } catch (err) {
      console.error("Failed fetch history reports");
    }
  }
}
